export const REACT_APP_API_GRAPHQL_URL = 'https://api.mobi.vamoscap.com.br/graphql';

export const MAPBOX_KEY = 'a'
